<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import collect from 'collect.js'

export default {
    mixins: [HasLoadingState, ManagesModalState, RestoreOnPageBack],

    props: ['platforms', 'dataBrand'],

    data() {
        return {
            brand: this.dataBrand,
            insights: this.dataBrand.insights,
            instagram: collect(this.platforms).firstWhere('slug', 'instagram_business'),
            form: new SparkForm({}),
            activeAmbassadorships: {},
            inactiveAmbassadorships: {},
        }
    },

    computed: {
        params() {
            return {
                brand: this.dataBrand,
            }
        },
        shortenLastName(ambassadorship) {
            return ambassadorship.influencer.name.split(' ')
        },
    },

    created() {
        this.onPageRestore(() => this.load(true))
        this.onPageVisit(() => this.load())
    },

    methods: {
        load(silently) {
            this.getAmbassadorships('active')
                .then(response => {
                    this.activeAmbassadorships = response.data.data
                })
                .then(this.saveState)
            this.getAmbassadorships('stopped')
                .then(response => {
                    this.inactiveAmbassadorships = response.data.data
                })
                .then(this.finishLoading(silently))
                .then(this.saveState)
        },

        getAmbassadorships(status) {
            return axios.get(
                route('api.brand.ambassadorships', this.brand) + '?filter[status]=' + status
            )
        },

        setUpdatedBrand(brand) {
            Object.assign(this.brand, brand)
        },
    },
}
</script>
